import React from 'react';
import PropTypes from 'prop-types';

class DataList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const columns = [];

    for (let i = 0; i < this.props.headers.length; i++) {
      columns.push((
        <div key={i} className={`data-list-th data-list-th--center data-list-5-col`}>{this.props.headers[i]}</div>
      ));
    }

    return (
      <div className="data-list">
        <div className="data-list-thead">
          <div className="data-list-th data-list-main-col">
            <em className="t-bold">
              {this.props.mainHeader}
            </em>
          </div>
          {columns}
        </div>
        <div className="data-list-tbody">
          {this.props.leads}
        </div>
      </div>
    );
  }
}


export default DataList;
